import React from "react";
import { Button, Badge } from "react-bootstrap";
import { useMessageScroll, useScrollStore, useVoiceRecorderStore } from "../model";

export const ScrollDownButton = React.memo(
  ({
    chatId,
    containerRef,
    replyingMessage,
    editingMessage,
  }: {
    chatId: string;
    containerRef: React.RefObject<HTMLDivElement | null>;
    replyingMessage: boolean;
    editingMessage: boolean;
  }) => {
    const unreadCount = useScrollStore((s) => s.unreadCount[chatId] ?? 0);
    const showScrollDown = useScrollStore(
      (s) => s.showScrollDown[chatId] ?? false
    );

    const voiceBlob = useVoiceRecorderStore((s) => s.voiceBlob);
    const recording = useVoiceRecorderStore((s) => s.recording);


    const { scrollToBottom } = useMessageScroll({
      chatId,
      messages: null, // Мы не передаем messages, потому что они могут быть не актуальны, но хук использует store
      chatContainerRef: containerRef,
      user: null,
    });


    // const baseOffset = editingMessage || replyingMessage ? 57 : 10;
    // const extraOffset = voiceBlob || recording ? 20 : 0;
    // const totalOffset = baseOffset + extraOffset;

    // if ((!unreadCount || unreadCount === 0) && !showScrollDown) return null;
    if (
      ((!unreadCount || unreadCount === 0) && !showScrollDown) ||
      recording ||
      voiceBlob
    ) {
      return null;
    }

    return (
      <Button
        variant="secondary"
        size="sm"
        className="position-absolute"
        style={{
          // bottom: `calc(100% + ${totalOffset}px)`,
          bottom: `calc(100% + ${
            editingMessage || replyingMessage ? 57 : 10
          }px)`,
          right: 0,
          width: 31,
          height: 31,
          zIndex: 1030,
        }}
        onClick={scrollToBottom}
      >
        <span className="position-relative">
          ↓
          {!!unreadCount && unreadCount > 0 && (
            <Badge
              bg="success"
              pill
              style={{
                position: "absolute",
                top: -17,
                right: -9,
                fontSize: "0.65rem",
              }}
            >
              {unreadCount}
            </Badge>
          )}
        </span>
      </Button>
    );
  }
);
